<template> 
 <div class="modal zoom" tabindex="-1" role="dialog" id="modalHistoricoCandidato"> 
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="destroy" ><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title text-left">Histórico do Candidato {{cpfCandidato}} </h4> 
      </div>
      <div class="modal-body"> 
         <div>  
          <div v-if="lista.length == 0 && primeiraPesquisa != true">
            <p class="text-center">:: Não existe nenhum registro desse candidato ::</p> 
          </div>
          <div v-else class="row"> 
          <div class="col-lg-6">
            <h4 class="text-left">Agendado/Espontâneo</h4>
              <div class="list-group list-group-item  text-left col-lg-12 comparecimentos" id="agendamentos" v-for="item of lista" :key="item.DataHorario" @click="historico(item.Id)">
                <p class="" style="display:inline-block; width:100%">
                  <span style=" float:left;">
                    <strong class="rotulos" >Nome: </strong> {{ item.Candidato.Nome }}
                  </span> 
                  <span style=" float:right;">
                    <strong class="rotulos" >Data: </strong> {{ formatarData(item.DataHorario) }}
                  </span>
                  </p>  
                  <p style="display:inline-block; width:100%">
                    <span style=" ">
                      <strong class="rotulos" >CPF: </strong> {{ item.Candidato.CPF }}
                    </span> 
                    <span style=" float:right; ">
                      <strong class="rotulos" >Unidade: </strong> {{ unidadeNome(item.UnidadeLuandre) }}
                    </span> 
                  </p>
              </div>  
          </div>
          <div class="col-lg-6">
            <h4 class="text-left">Histórico de Atendimento</h4>
            <ul class="list-group" > 
              <li  v-for="item of listaHistorico" class="list-complete-item list-group-item text-left col-lg-12 " :key="item" >  
      
              <span style=" width: 275px;display: inline-block;"><strong class="rotulos" >Atualizacao: </strong> {{ formatarData(item.DataAtualizacao) }}</span> <br />
              <span v-if="item.AtendidoPor" style=" width: 275px;display: inline-block;"><strong class="rotulos" >AtendidoPor: </strong> {{ item.AtendidoPor }}<br /></span> 
              <span style=" width: 275px;display: inline-block;"><strong class="rotulos" >Status: </strong> {{ status(item.Status) }}</span> <br />  
              <strong  class="rotulos" style="width: 275px;"> Obs.: </strong> <small>{{ item.Observacoes }}</small> 
              
              </li>  
            </ul>
            <div class="" v-if="this.listaHistorico.length == 0 ">
              <p class="text-left">Selecione alguma opção ao lado ou não há informações a serem exibidas.</p>
            </div>
          </div> 
          </div>
        </div>
      </div>
      <div class="modal-footer"> 
        <button type="button" class="btn btn-default" data-dismiss="modal" @click="destroy">Fechar</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal --> 
</template>
<script>
import moment from 'moment'
export default {
  name: 'listarAgendamentos',
  created () {
    // this.pesquisar()
  },
  components: {
    moment
  },
  computed: {
  },
  methods: {
    pesquisar: function (cpf) {
      this.$http.get('agendamento/cpf?cpf=' + cpf)
      .then(function (res) {
        this.lista = res.body
        this.primeiraPesquisa = false
      })
      .catch(function (err) {
        console.error(err)
      })
    },
    destroy () {
      this.lista = []
      this.listaHistorico = []
    },
    historico (id) {
      this.listaHistorico = []
      this.$http.get('agendamento/historico?id=' + id)
      .then(function (res) {
        this.listaHistorico = res.body
      })
      .catch(function (err) {
        console.error(err)
      })
    },
    formatarData: function (d) { return moment(String(d)).format('DD/MM/YYYY HH:mm') },
    unidadeNome: function (id) {
      let escrito = ''
      switch (id) {
        case 0:
          escrito = 'Matriz'
          break
        case 1:
          escrito = 'ABC'
          break
        case 2:
          escrito = 'Alphaville'
          break
        case 4:
          escrito = 'Campinas'
          break
        case 5:
          escrito = 'Curitiba'
          break
        case 6:
          escrito = 'Faria Lima'
          break
        case 7:
          escrito = 'Guarulhos'
          break
        case 8:
          escrito = 'Jundiaí'
          break
        case 10:
          escrito = 'Rio de Janeiro'
          break
        case 11:
          escrito = 'Santo Amaro'
          break
        case 14:
          escrito = 'Recife'
          break
      }
      return escrito
    },
    status (id) {
      let escrito = ''
      switch (id) {
        case 0:
          escrito = 'Agendado'
          break
        case 1:
          escrito = 'Em Atendimento'
          break
        case 2:
          escrito = 'Em Atendimento Coletivo'
          break
        case 3:
          escrito = 'Finalizado'
          break
        case 4:
          escrito = 'Exame Médico'
          break
        case 5:
          escrito = 'Reagendar'
          break
        case 6:
          escrito = 'Aguardando'
          break
        case 7:
          escrito = 'Removido'
          break
        case 8:
          escrito = 'Aguardando Retorno Candidato'
          break
      }
      return escrito
    },
    tipo: function (id) {
      let escrito = ''
      switch (id) {
        case 0:
          escrito = 'Admissão'
          break
        case 1:
          escrito = 'Rescisão'
          break
        case 2:
          escrito = 'Outros'
          break
      }
      return escrito
    }
  },
  data () {
    return {
      lista: [],
      listaHistorico: [],
      data: moment(),
      filtro: '',
      transition: 'list-group-item text-left transicaoInicio',
      primeiraPesquisa: true,
      proximoAgendamento: ''
    }
  },
  props: ['cpfCandidato']
}
</script>
<style scoped>
.rotulos {
  width: 50px; 
}
#agendamentos .list-group-item{
  cursor: pointer;
}
.comparecimentos{
  cursor: pointer;
}
.comparecimentos:hover{
  background: #ecf6ff;
}
/* .list-complete-item { 
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active { 
  transition: all 0s; 
}
.list-complete-enter-active { 
  transition: all 0.5s;
  background: #fffbeb;
}  */
</style>



// WEBPACK FOOTER //
// HistoricoCandidato.vue?497ddf08